const initialState = {

}

export default (state = initialState, { type, payload }) => {
    switch (type) {

    case "Test":
        return { ...state, ...payload }

    default:
        return state
    }
}
